<script>
export default {
  props: {
    socialProfiles: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // Скрытые сети (facebook/twitter/linkedin/github/instagram/tiktok)
      // возвращаются добавлением в список — данные в social_profiles не трогаем.
      socialMediaLinks: [
        { key: 'telegram', icon: 'brand-telegram', link: 'https://t.me/' },
        { key: 'vk', icon: 'chat', link: 'https://vk.com/' },
        // TODO: URL-формат MAX уточним с каналом
        { key: 'max', icon: 'chat', link: '' },
      ],
    };
  },
  computed: {
    availableProfiles() {
      return this.socialMediaLinks.filter(
        mediaLink => !!this.socialProfiles[mediaLink.key]
      );
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div v-if="availableProfiles.length" class="flex items-end gap-3 mx-0 my-2">
    <template v-for="profile in availableProfiles" :key="profile.key">
      <a
        v-if="profile.link"
        :href="`${profile.link}${socialProfiles[profile.key]}`"
        target="_blank"
        rel="noopener noreferrer nofollow"
      >
        <fluent-icon
          :icon="profile.icon"
          size="16"
          class="text-n-slate-11 hover:text-n-slate-10"
        />
      </a>
      <span
        v-else
        class="flex items-center gap-1 text-xs text-n-slate-11"
        :title="profile.key"
      >
        <fluent-icon :icon="profile.icon" size="16" class="text-n-slate-11" />
        {{ socialProfiles[profile.key] }}
      </span>
    </template>
  </div>
</template>
